import _ from 'lodash';

export const createDebouncedSaveHandler = () => {
    return _.debounce(async (saveHandler) => {
        await saveHandler();
    }, 500);
};
